"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _times = require("HubStyleTokens/times");

var _TwoWayTransition = _interopRequireDefault(require("../../transitions/TwoWayTransition"));

var _ModalTransitionContext = require("../../context/ModalTransitionContext");

var _overlayTransitionMixin = require("./overlayTransitionMixin");

var _UIDialog = _interopRequireDefault(require("../UIDialog"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", " {\n    transition-property: ", ";\n    transition-delay: ", "ms;\n    transition-duration: ", "ms;\n    transform: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var totalTransitionTime = parseInt(_times.SLIDEIN_MODAL_TRANSITION_TIMING, 10);
var overlayTransitionTime = parseInt(_times.MODAL_BACKGROUND_TRANSITION_TIMING, 10);
var dialogTransitionTime = totalTransitionTime - overlayTransitionTime;
var overlayTransition = (0, _overlayTransitionMixin.getOverlayTransition)(dialogTransitionTime);
var ModalPanelTransitionWrapper = (0, _styledComponents.default)(_TwoWayTransition.default.PlainWrapper).withConfig({
  displayName: "ModalPanelTransition__ModalPanelTransitionWrapper",
  componentId: "sc-16e4q3b-0"
})(_templateObject(), _UIDialog.default.Selector, function (_ref) {
  var transitionActive = _ref.transitionActive;
  return transitionActive ? 'transform' : 'none';
}, overlayTransitionTime, dialogTransitionTime, function (_ref2) {
  var hidden = _ref2.hidden,
      transitioning = _ref2.transitioning;
  return transitioning && "translateX(" + (hidden ? '100' : '0') + "%)";
}, overlayTransition);

var ModalPanelTransition = function ModalPanelTransition(props) {
  return _react.default.createElement(_TwoWayTransition.default, (0, _extends2.default)({}, props, {
    ContextProvider: _ModalTransitionContext.ModalTransitionContextProvider,
    duration: totalTransitionTime,
    transitionOnMount: true,
    Wrapper: ModalPanelTransitionWrapper
  }));
};

ModalPanelTransition.displayName = 'ModalPanelTransition';
var _default = ModalPanelTransition;
exports.default = _default;
module.exports = exports.default;